module.exports = __webpack_public_path__ + "static/media/rober3.447191eb.jpg";